import { render, staticRenderFns } from "./DataSchedule.vue?vue&type=template&id=1608c45d&scoped=true"
import script from "./DataSchedule.vue?vue&type=script&lang=js"
export * from "./DataSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608c45d",
  null
  
)

export default component.exports